import { ApplicationsPage } from './ApplicationsPage';

export function AiAgentsPage() {
  return <ApplicationsPage title="AI Agents" filterType="AI Agent" />;
}
